// extracted by mini-css-extract-plugin
export default {"Circulo":"Circulo_Circulo__2s8-C","label":"Circulo_label__4NLdr","Img":"Circulo_Img__GgU32","subContainer":"Circulo_subContainer__gDhGK","container":"Circulo_container__xDWMe"};